import { sv } from "css-variants";
import { useEmailThemeStore } from "./useEmailThemeStore";

/** @TODO In built exported on zustand v5 */
type ExtractState<S> = S extends { getState: () => infer T } ? T : never;

export type ThemeState = ExtractState<typeof useEmailThemeStore>;

export type StyleConfigFunction = (
  theme: ThemeState["defaultThemeVariables"],
) => Parameters<typeof sv>[0];

export const useStyle = (styleConfigFn: StyleConfigFunction) => {
  const defaultThemeVariables = useEmailThemeStore(
    state => state.defaultThemeVariables,
  );

  return (options = {}) => {
    const config = styleConfigFn(defaultThemeVariables);
    return sv(config)(options);
  };
};
